'use es6';

import PropTypes from 'prop-types';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { previewEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import { SaveBarContainer } from 'customer-data-properties/savebar/SaveBarContainer';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import RecordLink from 'crm-links/record/RecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UniversalSidebarPreviewFooter = ({
  objectTypeId,
  objectId,
  readOnly,
  hasErrors,
  hasChanges,
  isLoading,
  handleSave,
  handleCancel
}) => {
  if (readOnly) {
    return null;
  }
  return /*#__PURE__*/_jsx(PanelFooter, {
    "data-test-id": "preview-footer",
    paddingInline: "400",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      justify: "between",
      verticalGap: 14,
      children: [/*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: isLoading || hasErrors || !hasChanges,
          onClick: handleSave,
          "data-selenium-test": "PreviewSaveBar-button-primary",
          "data-test-id": "UniversalSidebarPreviewFooter-save",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "universalSidebarPreviewFooter.save"
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: !hasChanges,
          "data-selenium-test": "PreviewSaveBar-button",
          "data-test-id": "UniversalSidebarPreviewFooter-cancel",
          onClick: handleCancel,
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "universalSidebarPreviewFooter.cancel"
          })
        })]
      }), /*#__PURE__*/_jsx("span", {
        "data-selenium-test": "preview-footer-view-record",
        children: /*#__PURE__*/_jsx(RecordLink, {
          objectId: parseInt(objectId, 10),
          objectTypeId: ObjectTypesToIds[objectTypeId] || objectTypeId,
          hideIfNotSupported: true,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "universalSidebarPreviewFooter.viewRecord"
          })
        })
      })]
    })
  });
};
UniversalSidebarPreviewFooter.propTypes = {
  objectTypeId: PropTypes.string.isRequired,
  objectId: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  // from SaveBarContainer
  hasErrors: PropTypes.bool.isRequired,
  hasChanges: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
};
export default SaveBarContainer(UniversalSidebarPreviewFooter, previewEditableAreas);